import {
  BlogMetadataIntegrationState,
  BlogMetadataIntegrationHandlers,
} from '../../../hooks/useBlogMetadataIntegration'
import Styles from '../../../BlogMetadata.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { WixAuthorSelect } from '../WixAuthorSelect/WixAuthorSelect'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface WixIntegrationFieldsProps {
  integrationState: BlogMetadataIntegrationState
  handlers: BlogMetadataIntegrationHandlers
  isPostPublished: boolean
}

export const WixIntegrationFields: React.FC<WixIntegrationFieldsProps> = ({
  integrationState,
  handlers,
  isPostPublished,
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { selectedIntegration, selectedAuthorId, availableAuthors } = integrationState
  const { handleAuthorSelect } = handlers

  // Get Wix site name from the integration
  const wixSiteName = selectedIntegration?.name || 'Wix Site'

  return (
    <>
      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Blog</label>
        <div className={Styles.categoryDropdown}>
          <Text variant="secondary">{wixSiteName}</Text>
        </div>
      </div>

      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Writer</label>
        <div className={Styles.categoryDropdown}>
          <WixAuthorSelect
            members={availableAuthors}
            selectedAuthorId={selectedAuthorId}
            onAuthorSelect={handleAuthorSelect}
            disabled={isPostPublished}
            size={isSystemRedesignEnabled ? 'md' : 'lg'}
          />
        </div>
      </div>
    </>
  )
}
